export const checkErrorMessage = (message) => {
  const errorHandlers = {
    'Copied styles exceed product specifications': () => 'COPY_STYLES_ERRORS',

  };
  const errorTypes = Object.keys(errorHandlers);
  // eslint-disable-next-line no-restricted-syntax
  for (const errorType of errorTypes) {
    if (message.includes(errorType)) {
      return errorHandlers[errorType]();
    }
  }

  return 'UNKNOWN_ERROR';
};

export const containsSpecificError = (errorMessage, errorTypeChecker) => errorMessage.some(message => errorTypeChecker(message) !== 'UNKNOWN_ERROR');
